export default __webpack_public_path__ + "static/media/skin3_sprites.5a0ca5b2.png";